import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';

export const updateBookWidgetPassengerFn = (
  state: BookWidgetState,
  selectedPaxValue: string
) => {
  const options = [...state.fields.passengerField.dropdownOptions];
  const dropdownOptions = options.map((dropdownOption) => {
    if (dropdownOption.value === selectedPaxValue) {
      return { ...dropdownOption, selected: true };
    } else {
      return { ...dropdownOption, selected: false };
    }
  });
  return {
    ...state.fields.passengerField,
    selectedPaxValue,
    dropdownOptions
  };
};
